import {
  TextAlignKinds,
} from "../../../../domain/drawing";

export class TextAlignKindsTranslator {
  static toKind(code: number): TextAlignKinds {
    switch (code) {
      case 1:
        return TextAlignKinds.TopLeft;
      case 2:
        return TextAlignKinds.TopCenter;
      case 3:
        return TextAlignKinds.TopRight;
      case 4:
        return TextAlignKinds.MiddleLeft;
      case 5:
        return TextAlignKinds.MiddleCenter;
      case 6:
        return TextAlignKinds.MiddleRight;
      case 7:
        return TextAlignKinds.BottomLeft;
      case 8:
        return TextAlignKinds.BottomCenter;
      case 9:
        return TextAlignKinds.BottomRight;
    }
  }

  static fromKind(kind: TextAlignKinds): number {
    switch (kind) {
      case TextAlignKinds.TopLeft:
        return 1;
      case TextAlignKinds.TopCenter:
        return 2;
      case TextAlignKinds.TopRight:
        return 3;
      case TextAlignKinds.MiddleLeft:
        return 4;
      case TextAlignKinds.MiddleCenter:
        return 5;
      case TextAlignKinds.MiddleRight:
        return 6;
      case TextAlignKinds.BottomLeft:
        return 7;
      case TextAlignKinds.BottomCenter:
        return 8;
      case TextAlignKinds.BottomRight:
        return 9;
    }
  }
}
